// extracted by mini-css-extract-plugin
export var card = "_p0-0";
export var content = "_p0-2";
export var details = "_p0-3";
export var icon = "_p0-1";
export var iconBlue = "_p0-5";
export var iconBrand = "_p0-4";
export var iconGrayBlue = "_p0-6";
export var iconGreen = "_p0-7";
export var iconIndigo = "_p0-8";
export var iconOrange = "_p0-9";
export var iconPurple = "_p0-a";
export var iconRed = "_p0-b";
export var iconWarning = "_p0-c";